import React from 'react'
import { Button, Header, Image, Modal, 
  Form, Checkbox,
  Input
} from 'semantic-ui-react'
import unknown_user from '../../images/unknown_user.png'

function EditUserModal({user, toggleModal, show, saveUser, formConfigData }) {
  
  const [original, setOriginalUser] = React.useState(user)

  const [edituser, updateEditUser] = React.useState(user)

  const onUpdateField = (value, property) => {
    let user = {...edituser}
    user[property] = value;
    updateEditUser(user)
  }

  const userModified = () => { 
    for (const property in original) {
      if (edituser[property] !== original[property])        
        return true
    }
    return false
  }


  const getFormFieldsFromConfig = (config) => {
    let sorted_fields = config.editForm.sort((c, p) => {return c.displayOrder -  p.displayOrder} )

    return sorted_fields.map( (field, index) =>
              original.hasOwnProperty(field.fieldName) &&
              <Form.Field key={index}>
                <Input 
                  label={field.label}
                  placeholder={field.label}
                  value={edituser[field.fieldName] || ""} onChange={(e, data) => onUpdateField(data.value, field.fieldName) } />
                </Form.Field>
    )
  }

  


  return (
    <Modal
      onClose={() => toggleModal(false)}
      onOpen={() => toggleModal(true)}
      open={show}
    >
      <Modal.Header>
        <Image size='mini' src={unknown_user} wrapped spaced/>
        Uppdatera {user.GivenName} {user.FamilyName}
      </Modal.Header>
      <Modal.Content scrolling>
          <Form>
           {
            getFormFieldsFromConfig(formConfigData)
           }
          </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => toggleModal(false)}>
          Stäng
        </Button>
        <Button
          disabled={!userModified()}
          content="Spara ändringar"
          labelPosition='right'
          icon='checkmark'
          onClick={() => saveUser(edituser)}
          positive
        />
      </Modal.Actions>
    </Modal>
  )
}

export default EditUserModal
